import React, { ReactElement, useState } from "react";
import './DesktopFileViewLoadProgress.css';

const mocks: IProgress[] = [{
    current: 12,
    total: 16,
    fileId: 'test1',
    fileName: 'test file.abc'
},{
    current: 12,
    total: 36,
    fileId: 'test2',
    fileName: 'test432 file.abc'
}];

interface IProgress{
    current: number,
    total: number,
    fileName: string,
    fileId: string
}

interface IDesktopFileViewController {
    updateProgress: (progress: IProgress)=>void;
    removeProgress: (id: string)=>void
}

export const useDesktopFileViewLoadProgress = ():[IDesktopFileViewController, ReactElement] => {
 
    const [loadProgress, setLoadProgress] = useState<IProgress[]>([]);

    const controller: IDesktopFileViewController = {
        updateProgress: ({fileId, fileName, current, total})=>{
            setLoadProgress((last)=>{
                const found = last.find(it=>it.fileId == fileId);
                if (found){
                    return last.map(it=>it.fileId == found.fileId ? {...found, current, total} : it);
                }
                return [...last, {current, total, fileName, fileId}]
            });
        },
        removeProgress: (fileId)=>{
            setLoadProgress((last)=>last.filter(it=>it.fileId != fileId));
        }
    }

    const element = <>
        {(loadProgress && loadProgress.length >0) && <div className="DesktopFileView_loadProgress" onContextMenu={(e)=>e.stopPropagation()}>
            <div className="DesktopFileView_loadProgress_title">
                Uploading: 
            </div>
            {loadProgress.map(fileProgress=>{
                const percent = Math.floor(fileProgress.current / fileProgress.total * 100)+'%';
                return <div className="DesktopFileView_loadProgress_item">
                    <div className="DesktopFileView_loadProgress_item_top">
                        <div className="DesktopFileView_loadProgress_item_name">
                            {fileProgress.fileName+ ' - '}
                        </div>
                        <div className="DesktopFileView_loadProgress_item_percent">
                            {percent}
                        </div>
                    </div>
                    <div className="DesktopFileView_loadProgress_indicator">
                        <div className="DesktopFileView_loadProgress_bar" style={{width: percent}}>
                        </div>
                    </div>
                </div>
            })}
        </div>}
    </>

    return [controller, element];
}